import { getIn } from "formik";

export const getError = (
  name: string,
  {
    touched,
    error,
    status,
  }: { touched: boolean; error: string | undefined; status: unknown },
): string | undefined => {
  const backendError = getIn(status, `apiErrors.${name}`);

  if (error && touched) {
    return error;
  }
  if (backendError && !touched) {
    return backendError;
  }
  return undefined;
};

export const formatEvent = <TValue>(
  { value }: { value: TValue },
  name: string,
): { target: { value: TValue; name: string } } => ({
  target: { value, name },
});
